export class RequestEligibilityDetailsModel {
    productId: any;
    itemCode: any;
    quantity: number;
};
